import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderRolledPanelComponent } from './header-rolled-panel.component';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [HeaderRolledPanelComponent],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [HeaderRolledPanelComponent]
})
export class HeaderRolledPanelModule { }
